export const TOKEN_COOKIE = 'token';
export const REFRESH_COOKIE = 'refreshToken';

export const ACCESS_TOKEN_MAX_AGE_SECONDS = 60 * 60 * 24;
export const REFRESH_TOKEN_MAX_AGE_SECONDS = 60 * 60 * 24 * 30;

type AuthTokens = {
  accessToken: string;
  refreshToken: string;
};

type CookieWriter = (cookie: string) => void;

const isSecureCookie = () => process.env.NODE_ENV === 'production';

const buildCookie = (name: string, value: string, maxAgeSeconds: number) =>
  `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAgeSeconds}; samesite=lax${isSecureCookie() ? '; secure' : ''}`;

export function getClientCookieValue(cookieString: string, name: string): string | undefined {
  const rawValue = cookieString
    .split('; ')
    .find((row) => row.startsWith(`${name}=`))
    ?.split('=')
    .slice(1)
    .join('=');

  if (!rawValue) {
    return undefined;
  }

  try {
    return decodeURIComponent(rawValue);
  } catch {
    return rawValue;
  }
}

export function getClientAuthCookieSnapshot(cookieString: string) {
  return {
    token: getClientCookieValue(cookieString, TOKEN_COOKIE),
    refreshToken: getClientCookieValue(cookieString, REFRESH_COOKIE),
  };
}

export function hasClientAuthCookies(cookieString: string) {
  const { token, refreshToken } = getClientAuthCookieSnapshot(cookieString);
  return !!token || !!refreshToken;
}

export function writeClientAuthCookies(
  { accessToken, refreshToken }: AuthTokens,
  cookieWriter: CookieWriter = (cookie) => {
    document.cookie = cookie;
  },
) {
  cookieWriter(buildCookie(TOKEN_COOKIE, accessToken, ACCESS_TOKEN_MAX_AGE_SECONDS));
  cookieWriter(buildCookie(REFRESH_COOKIE, refreshToken, REFRESH_TOKEN_MAX_AGE_SECONDS));
}

export function clearClientAuthCookies(
  cookieWriter: CookieWriter = (cookie) => {
    document.cookie = cookie;
  },
) {
  cookieWriter(buildCookie(TOKEN_COOKIE, '', 0));
  cookieWriter(buildCookie(REFRESH_COOKIE, '', 0));
}
